import './LoadingComponent.style.less'
import { useEffect } from 'react'

import lottie from 'lottie-web'
import loading from '@/assets/lottie/data.json'

function LoadingComponent() {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector('#react-logo') as any,
      animationData: loading,
      renderer: 'svg', // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    })
  }, [])

  return (
    <div className="loading-container">
      <div id="react-logo" style={{ width: 400, height: 400 }} />
    </div>
  )
}

export default LoadingComponent
